import Typography from "@mui/material/Typography";
import styled from "@mui/material/styles/styled";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ProductsSliderCarousel from "../components/ProductsSliderCarousel";
import { useEffect } from "react";
import { getAllClientProducts } from "../redux/slices/giftsProductsSlice";
import { Stack } from "@mui/system";
import { getMe } from "../redux/slices/userSlice";
import { CircularProgress } from "@mui/material";

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: "#000000",
}));

const PointsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#F40002",
  padding: theme.spacing(2),
  borderRadius: "50%",
  width: "100px",
  height: "100px",
  marginBottom: theme.spacing(2),
  fontSize: "4rem",
  fontWeight: "bold",
  color: theme.palette.common.white,
  margin: "auto",
}));

function PointsReview() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const totalPoints = useSelector((state) => state.user.userMe?.current_points);
  const getAllClientProductsLoading = useSelector(
    (state) => state.giftsProducts.getAllClientProductsLoading
  );
  useEffect(() => {
    dispatch(getMe()).then(() => dispatch(getAllClientProducts()));
  }, [dispatch]);
  return (
    <Stack
      display="flex"
      direction="column"
      width="100%"
      justifyContent="space-between"
      alignItems="center"
      marginTop="36px"
    >
      <Stack display="flex" direction="column">
        <Title variant="h4">{t("pointsReview.totalPoints")}</Title>
        <PointsContainer>{totalPoints}</PointsContainer>
      </Stack>
      <Stack margin="36px auto">
        <Typography variant="h5">
          {t("pointsReview.productsAllowed")}
        </Typography>
      </Stack>
      {getAllClientProductsLoading === "PENDING" ? (
        <Stack
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <CircularProgress color="error" />
        </Stack>
      ) : (
        <ProductsSliderCarousel />
      )}
    </Stack>
  );
}

export default PointsReview;
